export const GAME_ID = 'nganya';
export const GAME_TITLE = 'Nganya';
export const PLAYHUB_URL = 'https://playhub.co.ke';

export const RUN = {
  durationSec: 60,
  crashLimit: 3,
  lanes: 3,
  countdownSec: 3,
  invulnMs: 1200,
  laneChangeMs: 160,
} as const;

export const SPEED = {
  /** Starting scroll speed — approachable for the first ~8s. */
  base: 210,
  /** Peak scroll speed near end of run. */
  max: 560,
  /** Extra ease-in so mid/late run feels clearly harder. */
  rampExponent: 1.25,
  /** Extra speed during final stretch / rush hour. */
  rushBonus: 55,
  finalStretchBonus: 70,
  boostMultiplier: 1.55,
  boostDurationMs: 1500,
  boostCooldownMs: 4200,
} as const;

export const SCORING = {
  farePoints: 10,
  nearMissPoints: 30,
  nearMissDistance: 46,
  distancePointsPer100: 6,
  comboMax: 8,
  comboStep: 0.2,
  missionBonus: 150,
  missionFareTarget: 12,
  /** Score multiplier grows with heat (0–1 → up to this bonus). */
  heatScoreBonus: 0.75,
  rushNearMissBonus: 15,
  styleStreakBonus: 40,
  styleStreakNeeded: 3,
} as const;

export const SPAWN = {
  minGapMs: 820,
  maxGapMs: 1700,
  /** Gap between hazards at max difficulty — still fair, but denser. */
  minGapAtMaxDiff: 380,
  collectibleChance: 0.38,
  bonusChance: 0.1,
  specialObstacleAtProgress: 0.32,
  maxSimultaneous: 18,
  reactionWindowMs: 620,
  /** Chance to spawn a second obstacle in another lane after mid-run. */
  dualSpawnAtProgress: 0.42,
  dualSpawnChance: 0.32,
  /** Traffic that changes lanes mid-approach. */
  weaveAtProgress: 0.35,
  weaveChance: 0.22,
  rushWeaveChance: 0.4,
} as const;

/** Competitive intensity / Rush Hour pacing. */
export const INTENSITY = {
  /** Heat gained on fare / near miss / style. */
  fareHeat: 4,
  nearMissHeat: 8,
  styleHeat: 6,
  crashHeatPenalty: 28,
  heatDecayPerSec: 3.2,
  heatMax: 100,
  /** Rush Hour wave cadence (seconds into the run). */
  firstRushAtSec: 18,
  rushIntervalSec: 14,
  rushDurationSec: 5.5,
  /** Last N seconds are Final Stretch. */
  finalStretchSec: 15,
} as const;

export const QUALITY = {
  particlesHigh: 18,
  particlesLow: 6,
  parallaxHigh: true,
  shakeIntensity: 0.006,
} as const;

export const COLORS = {
  asphalt: 0x2a2f38,
  asphaltLine: 0xf5d76e,
  roadside: 0x1a3a28,
  skyTop: 0xff9a3c,
  skyBottom: 0xffd59a,
  hudGold: '#ffd166',
  hudRed: '#ef476f',
  hudGreen: '#06d6a0',
  brand: '#e85d04',
} as const;

export type QualityLevel = 'auto' | 'high' | 'low';
